import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Secondary as DSSecondary } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./secondary.module.css";
export var Secondary = function(_param) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, innerRef = _param.innerRef, rest = _object_without_properties(_param, [
        "className",
        "children",
        "innerRef"
    ]);
    return _jsx(DSSecondary, _object_spread_props(_object_spread({
        classNames: {
            button: cx(styles.root, className)
        }
    }, rest), {
        ref: innerRef,
        children: children
    }));
};
